// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const victoryArch = defineModel({
  id: "victory-arch",
  batchId: "future",
  name: "Victory arch",
  tags: ["building","victory","arch","low-poly","age-of-mcp","future"],
  summary: "A triumphal arch — a grand prestige monument.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.28, 0.14, 1.28), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.28, 0.14, 1.28), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.5, 0.34), color: "#b3a892", position: [-0.42, 0.39, 0] },
      { geometry: new THREE.BoxGeometry(0.4, 0.1, 0.4), color: "#928873", position: [-0.42, 0.19, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.5, 0.34), color: "#b3a892", position: [0.42, 0.39, 0] },
      { geometry: new THREE.BoxGeometry(0.4, 0.1, 0.4), color: "#928873", position: [0.42, 0.19, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.54, 0.5, -0.54] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.54, 0.5, -0.54] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.54, 0.5, 0.54] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.54, 0.5, 0.54] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.28, 0.14, 1.28), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.95, 0.34), color: "#b3a892", position: [-0.42, 0.615, 0] },
      { geometry: new THREE.BoxGeometry(0.4, 0.1, 0.4), color: "#928873", position: [-0.42, 0.19, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.95, 0.34), color: "#b3a892", position: [0.42, 0.615, 0] },
      { geometry: new THREE.BoxGeometry(0.4, 0.1, 0.4), color: "#928873", position: [0.42, 0.19, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.8, 4), color: "#6b4a26", position: [-0.54, 0.9, -0.54] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.8, 4), color: "#6b4a26", position: [0.54, 0.9, -0.54] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.8, 4), color: "#6b4a26", position: [-0.54, 0.9, 0.54] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.8, 4), color: "#6b4a26", position: [0.54, 0.9, 0.54] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.28, 0.14, 1.28), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.95, 0.34), color: "#b3a892", position: [-0.42, 0.615, 0] },
      { geometry: new THREE.BoxGeometry(0.4, 0.1, 0.4), color: "#928873", position: [-0.42, 0.19, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.95, 0.34), color: "#b3a892", position: [0.42, 0.615, 0] },
      { geometry: new THREE.BoxGeometry(0.4, 0.1, 0.4), color: "#928873", position: [0.42, 0.19, 0] },
      { geometry: new THREE.BoxGeometry(0.14, 0.12, 0.38), color: "#928873", position: [-0.29, 1.09, 0], rotation: [0, 0, -1.570796] },
      { geometry: new THREE.BoxGeometry(0.14, 0.12, 0.38), color: "#b3a892", position: [-0.261281, 1.215826, 0], rotation: [0, 0, -1.121997] },
      { geometry: new THREE.BoxGeometry(0.14, 0.12, 0.38), color: "#928873", position: [-0.180812, 1.316731, 0], rotation: [0, 0, -0.673198] },
      { geometry: new THREE.BoxGeometry(0.14, 0.12, 0.38), color: "#b3a892", position: [-0.064531, 1.372729, 0], rotation: [0, 0, -0.224399] },
      { geometry: new THREE.BoxGeometry(0.14, 0.12, 0.38), color: "#928873", position: [0.064531, 1.372729, 0], rotation: [0, 0, 0.224399] },
      { geometry: new THREE.BoxGeometry(0.14, 0.12, 0.38), color: "#b3a892", position: [0.180812, 1.316731, 0], rotation: [0, 0, 0.673198] },
      { geometry: new THREE.BoxGeometry(0.14, 0.12, 0.38), color: "#928873", position: [0.261281, 1.215826, 0], rotation: [0, 0, 1.121997] },
      { geometry: new THREE.BoxGeometry(0.14, 0.12, 0.38), color: "#b3a892", position: [0.29, 1.09, 0], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.BoxGeometry(1.18, 0.34, 0.38), color: "#b3a892", position: [0, 1.59, 0] },
      { geometry: new THREE.BoxGeometry(1.26, 0.08, 0.44), color: "#928873", position: [0, 1.41, 0] },
      { geometry: new THREE.BoxGeometry(1.08, 0.26, 0.34), color: "#b3a892", position: [0, 1.89, 0] },
      { geometry: new THREE.BoxGeometry(0.5, 0.16, 0.36), color: "#8a8070", position: [0, 1.89, 0] },
      { geometry: new THREE.BoxGeometry(0.2, 0.06, 0.1), color: "#d8b24a", position: [0, 2.05, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.03, 0.12, 6), color: "#d8b24a", position: [-0.05, 2.13, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.03, 0.12, 6), color: "#d8b24a", position: [0.05, 2.13, 0] },
    ] },
  ],
  animations: [],
});
